module.exports = __webpack_public_path__ + "img/HKG.bbb0a7db.svg";